import gql from "graphql-tag";

export default gql`
  query getPortfolioExport($input: PortfolioExportInput!, $offset: OffsetInput) {
    getPortfolioExport(input: $input, offset: $offset) {
      columns
      rows
    }
  }
`;
